import type { IEventRepository, GetEventsParams } from '@/domain/repositories/event.repository'
import type { Event } from '@/domain/entities/event.entity'
import { eventsContract } from '@bibleawr/landing2-contract'
import { createLandingTsRestClient } from '../api/ts-rest-client'
import { mapEventDtoArrayToEntities, mapEventDtoToEntity } from '../mappers/event.mapper'
import { toNumberOrNull } from '@/utils/value.helpers'

export class EventRepository implements IEventRepository {
  private readonly client = createLandingTsRestClient(eventsContract)

  async findMany (params?: GetEventsParams): Promise<Event[]> {
    const res = await this.client.getEvents({
      query: { event_locale: params?.event_locale, limit: params?.limit },
    })
    if (res.status !== 200) throw new Error(`getEvents failed: ${res.status}`)
    const dtos = Array.isArray(res.body.data) ? res.body.data : []
    return mapEventDtoArrayToEntities(dtos)
  }

  async findBySlug (slug: string): Promise<Event | null> {
    const res = await this.client.getEventBySlug({ params: { slug } })
    if (res.status === 404) return null
    if (res.status !== 200) throw new Error(`getEventBySlug failed: ${res.status}`)
    const raw = res.body.data
    if (!raw?._id) return null
    return mapEventDtoToEntity(raw)
  }

  async incrementView (eventId: string): Promise<number | null> {
    const res = await this.client.incrementEventView({ params: { event_id: eventId }, body: {} })
    if (res.status === 404) return null
    if (res.status !== 200) throw new Error(`incrementEventView failed: ${res.status}`)
    return toNumberOrNull(res.body.data?.event_views)
  }
}
